<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ system_entry_obj }} -->
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-6 mb-2">
            <label for="OwnerNo" class="form-label">主催者コード</label>
            <input
              type="text"
              class="form-control"
              id="OwnerNo"
              placeholder="主催者コード"
              :disabled="!form_editable"
              v-model="(system_entry_obj || {}).owner_no"
            />
          </div>
          <div class="col-6 mb-2">
            <label for="BirthDate" class="form-label">主催者名</label>
            <input
              type="text"
              class="form-control"
              id="BirthDate"
              placeholder="生年月日"
              :disabled="!form_editable"
              v-model="(system_entry_obj || {}).owner_label"
            />
          </div>
          <div class="col-3 mb-2">
            <label for="UpperLicenseCd" class="form-label">状況</label>
            <bs-select
              :options="app_flg_list"
              v-model="(system_entry_obj || {}).app_flg"
              :null-option="false"
              :disabled="!form_editable"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-3 mb-2"></div>
          <div class="col-3 mb-2">
            <label for="UpperLicenseCd" class="form-label"
              >オプション機能</label
            >
            <bs-select
              :options="free_style_list"
              v-model="(system_entry_obj || {}).RACE_FREE_STYLE_TEXT_SW"
              :null-option="false"
              :disabled="!form_editable"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
      </div>
      <!-- {{race_series_obj.license_exclude}} -->
    </div>
    <div class="position-relative d-none" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-5 mb-2">
            <h4>申請情報</h4>
            <div>
              {{ system_entry_obj }}
            </div>
            <table class="table">
              <tbody>
                <tr v-for="item in system_entry_obj?.items" :key="item">
                  <th style="width: 30%">
                    {{ get_list_label(item.migration_key, migration_key_list) }}
                  </th>
                  <td v-if="item.migration_key.startsWith('photo_type_')">
                    <span v-if="system_entry_obj?.del_file_flg >= 1"
                      >移行済</span
                    >
                    <img :src="item?.migration_value" class="w-100" v-else />
                  </td>
                  <td v-else-if="item.migration_key == 'identify_type'">
                    {{
                      get_list_label(
                        item?.migration_value,
                        identify_type_cd_obj
                      )
                    }}
                  </td>
                  <td v-else-if="item.migration_key == 'login_pass'">******</td>
                  <td v-else-if="form_editable">
                    <input
                      type="text"
                      v-model="(item || {}).migration_value"
                      class="form-control"
                    />
                  </td>
                  <td v-else>
                    {{ item?.migration_value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
      style="z-index: 110"
    >
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            v-if="form_editable"
            type="submit"
            @click="chg_mode('view')"
            class="btn btn-light btn-outline-secondary"
          >
            照会に戻る
          </button>
          <button
            v-else
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="
            system_entry_obj.app_flg == 0 &&
            chk_relation_type_editable('/system_entry/data')
          "
        >
          <button type="submit" @click="go_app" class="btn btn-success">
            承認する
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-else-if="
            system_entry_obj.app_flg == 1 &&
            chk_relation_type_editable('/system_entry/data')
          "
        >
          <button type="submit" class="btn btn-dark">完了</button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center" v-else>
          <button disabled class="btn btn-dark">--</button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-end"
          v-if="chk_relation_type_editable('/system_entry/data')"
        >
          <button
            type="submit"
            @click="chg_mode('edit')"
            class="btn btn-warning"
            v-if="mode == 'view'"
          >
            編集する
          </button>
          <button
            type="submit"
            @click="go_update"
            class="btn btn-primary"
            v-else-if="mode == 'edit'"
          >
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'

export default {
  name: 'SystemEntryDetail',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '申請データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      system_entry_obj: {},
      mode: 'view',
      pref_obj: [],
      identify_type_cd_obj: [],
      license_cd_obj: [],
      add_license_form: [],
      app_flg_list: [
        {
          key: 0,
          label: '申請'
        },
        {
          key: 1,
          label: '完了'
        }
      ],
      free_style_list: [
        {
          key: 0,
          label: '使用しない'
        },
        {
          key: 1,
          label: '使用する'
        }
      ],
      migration_key_list: [
        {
          key: 'mail_address',
          label: 'メールアドレス'
        },
        {
          key: 'up_mail_address',
          label: '更新アドレス'
        },
        {
          key: 'login_id',
          label: 'ログインID'
        },
        {
          key: 'login_pass',
          label: 'ログインパス'
        },
        {
          key: 'identify_type',
          label: '本人確認書類種類'
        },
        {
          key: 'photo_type_1',
          label: '顔写真'
        },
        {
          key: 'photo_type_2',
          label: '本人確認書類1'
        },
        {
          key: 'photo_type_3',
          label: '本人確認書類2'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    add_license() {
      const add_form = {
        id: 0,
        stat: 1,
        migration_id: this.targetid,
        license_no: (this.system_entry_obj || {}).license_no,
        license_cd: 0,
        license_event_cd: 0,
        license_year: '',
        license_add_type: '',
        license_term_start_date: '',
        license_term_end_date: ''
      }
      const adds = [...this.add_license_form]
      adds.push({ ...add_form })
      this.add_license_form = adds
    },
    back() {
      this.$router.go(-1)
    },
    chg_mode(mode) {
      this.mode = mode
    },
    async go_app() {
      const params = { ...this.system_entry_obj }

      params.app_flg = 1
      // console.log('go_app params', params)
      await this.update(params)
    },
    async go_update() {
      const params = this.system_entry_obj
      if (
        Array.isArray(this.add_license_form) &&
        this.add_license_form.length > 0
      ) {
        const tmps = [...params.license]
        this.add_license_form.map(license_form => {
          tmps.push(license_form)
        })
        this.add_license_form = []
        params.license = tmps
      }
      // console.log('go_app params', params)
      await this.update(params)
    },
    async update(params) {
      const url = this.not_add
        ? config.BASE_API_URL + '/entry_owner_setting/edit/' + this.targetid
        : config.BASE_API_URL + '/entry_owner_setting/add'

      await this.basicPosts_I(url, params)
        .then(async response => {
          console.log('update response', response)
          if (response?.data?.status === 200) {
            alert('更新しました')
            this.mode = 'view'
            await this.loadEntrySettingList()
          } else {
            alert('error')
          }
        })
        .catch(async err => {
          console.log(err)
          this.system_entry_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEntrySettingList() {
      const params = {}
      params['id'] = this.not_add ? this.targetid : 0
      params['list_search'] = 1
      await this.basicPosts_S(
        config.BASE_API_URL + '/entry_owner_setting/lists',
        params
      )
        .then(async response => {
          console.log('loadMigrationList response', response)
          const mobj = response?.data?.body ? response.data.body[0] : {}
          if (Array.isArray(mobj?.license)) {
            mobj.license = mobj.license.map(license => {
              license.del_flg = 0
              return license
            })
          }

          this.system_entry_obj = mobj
        })
        .catch(async err => {
          console.log(err)
          this.system_entry_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  computed: {
    get_license_label: function () {
      const get_func = this.get_license_data
      return function (license_id) {
        if (get_func(license_id)) {
          return get_func(license_id)?.label
        }
        return ''
      }
    },
    get_license_data: function () {
      const license_cd_obj = this.license_cd_obj
      return function (license_cd) {
        return license_cd_obj.find(license => license.id == license_cd)
      }
    },
    license_cd_list: function () {
      return this.license_cd_obj
    },
    ...mapState({}),
    get_list_label: function () {
      return function (key, lists) {
        // if (key === '0') return '未選択'
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    form_editable: function () {
      return this.mode == 'edit' ? true : false
    }
  },

  async created() {
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadEntrySettingList()
      this.btnLabel = '更新'
    } else {
      this.system_entry_obj = {
        id: 0,
        owner_obj: '',
        m_id: 0,
        birth_date: '',
        items: []
      }
      this.btnLabel = '登録'
      // await this.loadRaceSeriesList()
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '申請データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
